function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { Box, Flex, Text } from '@tapresearch/ui/components';
import { QuestionNumber } from '../common/QuestionNumber';
import useAsset from '../hook/useAsset';
export var QuestionResultWrapper = function(_param) {
    var children = _param.children, tapQuestion = _param.tapQuestion, headerRightContent = _param.headerRightContent, totalRespondents = _param.totalRespondents, _param_isLongitudinalView = _param.isLongitudinalView, isLongitudinalView = _param_isLongitudinalView === void 0 ? false : _param_isLongitudinalView, rest = _object_without_properties(_param, [
        "children",
        "tapQuestion",
        "headerRightContent",
        "totalRespondents",
        "isLongitudinalView"
    ]);
    var active_enum = useAsset().active_enum;
    var questionType = active_enum.TapAnswerType[tapQuestion.tap_answer_type.toString()];
    return /*#__PURE__*/ React.createElement(Box, _object_spread_props(_object_spread({
        bg: 'white',
        boxShadow: 'md',
        mb: 8,
        pb: isLongitudinalView ? 0 : 8
    }, rest), {
        "data-testid": "question-result-wrapper"
    }), /*#__PURE__*/ React.createElement(Flex, {
        p: 6,
        pb: 0,
        fontSize: "lg",
        fontWeight: "medium",
        color: "gray.800",
        justify: "space-between",
        align: "flex-start"
    }, /*#__PURE__*/ React.createElement(Flex, {
        align: "center"
    }, /*#__PURE__*/ React.createElement(QuestionNumber, {
        textStyles: {
            color: 'blue.500',
            fontWeight: 'medium'
        },
        num: tapQuestion.position
    }), /*#__PURE__*/ React.createElement(Box, null, tapQuestion.question_text, /*#__PURE__*/ React.createElement(Flex, {
        fontSize: '14px',
        color: 'gray.400',
        fontWeight: 'normal',
        p: 0,
        top: '8px',
        my: 1,
        position: 'relative'
    }, questionType, ' ', tapQuestion.allows_multiple_selection && '(multi-select)', totalRespondents && /*#__PURE__*/ React.createElement(Box, {
        ml: 10
    }, "Responses:", ' ', /*#__PURE__*/ React.createElement(Text, {
        fontWeight: "semibold",
        color: "gray.700"
    }, totalRespondents))))), /*#__PURE__*/ React.createElement(Flex, {
        align: "right"
    }, headerRightContent)), /*#__PURE__*/ React.createElement(Flex, {
        w: "full",
        "data-testid": "chart-container"
    }, children));
};
